import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <section className="home">
      <div className="home-inner">
        <div className="hero">
          <h1 className="hero-name">Jericho F.<span className="cursor">_</span></h1>
          <p className="hero-role">Data Scientist</p>
          <p className="hero-skills">Python · SQL · Spark · React</p>
        </div>

        <div className="hero-divider"></div>

        <nav className="hero-nav">
          <Link to="/projects" className="arrow-link">
            <span className="arrow">→</span> Selected Work
          </Link>
          <Link to="/about" className="arrow-link">
            <span className="arrow">→</span> About
          </Link>
          <Link to="/contact" className="arrow-link">
            <span className="arrow">→</span> Contact / GitHub
          </Link>
        </nav>
      </div>
    </section>
  );
};

export default Home;
